import { resolveAppData } from '@/logic/app-data';
import { isNativeApiAllowedRoute } from '@/logic/app-data/app-data-route';
import { getPageConfig } from '@/lib/aggregation';
import type { Experiment } from '@/types/aggregation/home';
import { getCategoryChromeSource } from '@/logic/layout-adapter/get-category-chrome-source';

export const getExperiments = async ({ currentRoute }: { currentRoute: string }): Promise<Experiment> => {
    const chrome = await getCategoryChromeSource(currentRoute);
    if (chrome.source === 'gfe') {
        return chrome.response.experiments ?? {};
    }

    if (!isNativeApiAllowedRoute(currentRoute)) {
        return (await getPageConfig(currentRoute))?.experiments ?? {};
    }
    return (await resolveAppData(currentRoute))?.experiments ?? {};
};
